import { Users, PenLine, Sun, TrendingDown, Briefcase, Heart, Pill, Shield } from 'lucide-react';
import { WHATSAPP_URL } from '../constants';
import { useScrollReveal } from '../hooks/useScrollReveal';

const benefits = [
  {
    icon: Users,
    title: 'Confiança Social',
    desc: 'Abrace sem medo. Aperto de mão seguro. Não pense mais no suor em nenhuma situação social.',
  },
  {
    icon: PenLine,
    title: 'Escreva Sem Problemas',
    desc: 'Sem mais caneta escorregando ou papel manchado. Escreva e assine documentos com segurança.',
  },
  {
    icon: Sun,
    title: 'Roupas Sem Limite',
    desc: 'Use cores claras e tecidos que realmente gosta. Sem manchas, sem constrangimentos.',
  },
  {
    icon: TrendingDown,
    title: 'Sem Custos Contínuos',
    desc: 'Uma cirurgia, solução permanente. Sem gastos mensais com remédios ou tratamentos paliativos.',
  },
  {
    icon: Briefcase,
    title: 'Vida Profissional',
    desc: 'Entrevistas, apresentações, reuniões sem ansiedade. Foque no que realmente importa.',
  },
  {
    icon: Heart,
    title: 'Relacionamentos',
    desc: 'Intimidade e contato físico sem constrangimento. Conecte-se de verdade com as pessoas.',
  },
  {
    icon: Pill,
    title: 'Sem Medicação Diária',
    desc: 'Liberdade de não depender de remédios contínuos ou aplicações de botox periódicas.',
  },
  {
    icon: Shield,
    title: 'Resultado Permanente',
    desc: 'Uma única cirurgia. Para a vida toda. Sem necessidade de repetir o procedimento.',
  },
];

export default function BenefitsSection() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section id="beneficios" ref={ref} className={`py-24 md:py-32 bg-[#F0F9F7] transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">

        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center bg-[#0D47A1]/10 text-[#0D47A1] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
            Transformação Real
          </div>
          <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-6 leading-tight">
            O Que Muda na Sua Vida Após a Cirurgia
          </h2>
          <p className="text-base md:text-lg text-[#212121]/70 leading-relaxed">
            Imagine o alívio de colocar uma camiseta colorida sem medo. De cumprimentar alguém sem pensar na
            mão molhada. Isso não é fantasia. É realidade comprovada para 95% dos nossos pacientes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
          {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return (
              <div
                key={i}
                data-testid={`benefit-card-${i + 1}`}
                className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group"
              >
                <div className="w-12 h-12 rounded-xl bg-[#00897B]/10 flex items-center justify-center mb-4 group-hover:bg-[#00897B]/20 transition-colors">
                  <Icon size={22} className="text-[#00897B]" />
                </div>
                <h3 className="font-poppins font-bold text-base text-[#212121] mb-2">
                  {benefit.title}
                </h3>
                <p className="text-[#212121]/65 text-sm leading-relaxed">
                  {benefit.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-[#212121]/60 text-sm mb-4 italic">
            Viver isso é possível. Agende sua consulta.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="benefits-cta-button"
            className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-bold px-10 py-4 rounded-full hover:bg-[#00897B] transition-colors duration-200 shadow-lg hover:-translate-y-0.5"
          >
            QUERO AGENDAR MINHA CONSULTA
          </a>
        </div>

      </div>
    </section>
  );
}
